import React, { FunctionComponent, ReactElement } from 'react'
import bestGotchi from '@assets/images/home/best-gotchi.png'
import './DatagotchiBrandMark.scss'

type Props = {
  label: string
  className?: string
}

/** best-gotchi + « Portail » (marque globale éditions). */
export const DatagotchiBrandMark: FunctionComponent<Props> = ({ label, className }): ReactElement => {
  return (
    <span className={`DatagotchiBrandMark${className ? ` ${className}` : ''}`}>
      <img className="DatagotchiBrandMark-logo" src={bestGotchi} alt="" />
      <span className="DatagotchiBrandMark-label">{label}</span>
    </span>
  )
}

export default DatagotchiBrandMark
